<template>
    <jet-banner class="w-full" />
    <div :class="{ 'dark': store.state.global.isDark }">
        <div class="relative bg-black overflow-hidden">
            <Head title="">
                <meta inertia property="og:title" content="Join Racing Stars to Win Daily & Weekly Jackpots" />
                <meta inertia property="og:description" content="We level the playing field with our revolutionary points system, to give everyone a chance of winning." />
                <meta inertia property="og:image" :content="asset('images/og-image.jpg')" />
            </Head>
            <div class="h-1 bg-racing-stars-yellow"></div>
            <div class="relative">
                <main>
                    <slot></slot>
                </main>
                <footer class="bg-darkgray">
                    <div class="max-w-7xl mx-auto py-6 px-4 overflow-hidden sm:px-6 lg:px-8">

                        <p class="mt-8 text-center text-base text-gray-400">
                            Copyright &copy; {{ moment().format('YYYY') }} Racing Stars Ltd. All Rights Reserved.<br />
                            Racing Stars Ltd, 61 Alexandra Road, Lowestoft. NR32 1PL<br />
                            <strong>Company Registration Number</strong>: 12126618<br />
                            <!-- <strong>Racing Stars is a Registered Trademark</strong>: <a href="https://trademarks.ipo.gov.uk/ipo-tmcase/page/Results/1/UK00003475231">UK00003475231</a><br /> -->
                        </p>
                    </div>
                </footer>
            </div>
        </div>
    </div>
    <chat />
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { MenuIcon, XIcon } from '@heroicons/vue/outline'
import { ChevronRightIcon } from '@heroicons/vue/solid'
import ApplicationLogo from '@/Jetstream/ApplicationLogo'
import FooterSection from '@/Layouts/Partials/Footer.vue'
import Chat from '@/Global/Chat.vue'
import axios from 'axios'
import { ref, reactive, onMounted, computed, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import moment from 'moment'
import JetBanner from '@/Jetstream/Banner'
import { Inertia } from '@inertiajs/inertia'
import { useGtm } from '@gtm-support/vue-gtm'
export default {
    props: {
        user: Object,
        racingstars: Object,
    },
    components: {
        Popover,
        PopoverButton,
        PopoverPanel,
        ChevronRightIcon,
        MenuIcon,
        XIcon,
        ApplicationLogo,
        Link,
        FooterSection,
        JetBanner,
        Chat,
        Head,
    },
    setup(props) {
        /*
        |--------------------------------------------------------------------------
        | Properties
        |--------------------------------------------------------------------------
        */
        /**
         * The VueX store.
         *
         * @type {Object}
         */
        const store = useStore()
        /**
         * Google Tag Manage Instance.
         *
         * @type {Object}
         */
        const gtm = useGtm();
        /**
         * Formatter function required to format currencies/prices correctly.
         *
         * @type {Intl}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })
        /**
         * Navigation.
         *
         * @type {Array}
         */
        const navigation = [
            { name: 'Jackpots', href: '#jackpots' },
            { name: 'Tokens', href: '#tokens' },
            { name: 'Horses', href: '#horses' },
            { name: 'Betting', href: '#betting' },
            { name: 'Selections', href: '#change' },
            { name: 'Points', href: '#points' },
        ]
        /**
         * Mounted.
         */
        onMounted(() => {
            Inertia.reload()
            const html = document.documentElement
            const body = document.body
            if (html.classList.contains('racingstars')) {
                html.classList.remove('racingstars')
            }
            if (body.classList.contains('racingstars')) {
                body.classList.remove('racingstars')
            }
            store.commit('setDarkModeIfUndefined')
            if (props.user && props.racingstars.env === 'production') {
                gtm.trackEvent({
                    event: 'User Logged In',
                    user: {
                        name: props.user.name,
                        email: props.user.email,
                        id: props.user.uuid,
                        created_at: props.user.created_at_timestamp,
                        mobile: props.user.mobile,
                        user_hash: props.user.hash,
                        avatar: props.user.profile_photo_url,
                    }
                });
            }
        })
        /*
        |--------------------------------------------------------------------------
        | Methods
        |--------------------------------------------------------------------------
        */
        return {
            store,
            formatter,
            moment,
            navigation,
        }
    }
}
</script>
